import styled from '@emotion/styled'
import { color, fontWeight } from 'stylist'

const PlainLink = styled.a`
  color: ${color('ocean')};
  ${fontWeight('regular')};
  text-decoration: none;

  &:hover {
    color: ${color('darkOcean')};
    cursor: pointer;
  }
`

export default PlainLink



// WEBPACK FOOTER //
// ./src/components/PlainLink.js